var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19995 1H10.7999C12.7798 1 13.7698 1 14.3848 1.61508C14.9999 2.23015 14.9999 3.2201 14.9999 5.2V6.6C14.9999 8.57988 14.9999 9.56982 14.3848 10.1849C13.7698 10.8 12.7798 10.8 10.7999 10.8H5.19995",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09994 3.80057C2.67515 4.21346 0.999939 5.31236 0.999939 5.90057C0.999939 6.48878 2.67515 7.58771 3.09994 8.00057",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92218 3.80057C8.34694 4.21346 10.0222 5.31236 10.0222 5.90057C10.0222 6.48878 8.34694 7.58771 7.92218 8.00057",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999939 5.90147H9.39993",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesB);
export default __webpack_public_path__ + "static/media/sales-b.6f1b48452501a965bdeee01d0cc7954d.svg";
export { ForwardRef as ReactComponent };